/* eslint-disable */
import { useCallback, useEffect, useState } from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { CashStack, PersonCircle } from 'react-bootstrap-icons';
import { Helmet } from 'react-helmet';
import logoCaBlackImg from 'src/assets/images/logo-ca-black.png';
import logoCaWhiteImg from 'src/assets/images/logo-ca-white.png';
import logoHsBlackImg from 'src/assets/images/logo-hs-black.png';
import logoPgBlackImg from 'src/assets/images/logo-pg-black.png';
import logoPgWhiteImg from 'src/assets/images/logo-pg-white.png';
import logoPpBlackImg from 'src/assets/images/logo-pp-black.png';
import logoPpWhiteImg from 'src/assets/images/logo-pp-white.png';
import logoPxPlayBlackImg from 'src/assets/images/logo-pxplay-black.png';
import logoPxPlayWhiteImg from 'src/assets/images/logo-pxplay-white.png';
import logoRectImg from 'src/assets/images/logo-rectangle.png';
import logoTdBlackImg from 'src/assets/images/logo-td-black.png';
import logoRevengeImg from 'src/assets/images/logo.png';
import { useAppContext } from 'src/context/appContext';
import useTheme from 'src/hooks/useTheme';
import './index.scss';
import LanguageSwitch from './LanguageSwitch';
import ThemeSwitch from './ThemeSwitch';

const url = new URL(window.location.href);
const params = url.searchParams;
const oc = params.get('oc') ?? '';

const pxplayOcs = ['cldemo1', 'tpowerdev', 'pxdemo'];
const pxplayDomains = ['pxplay88.com', 'pxplaygaming.com'];
export const isPxplay =
  pxplayOcs.includes(oc) ||
  pxplayDomains.includes(url.hostname) ||
  pxplayDomains.includes(url.host) ||
  params.get('logo') === 'pxplay';

const rgOcs = ['cldemo2'];
export const isRg = rgOcs.includes(oc);

const caOcs = ['cademo2', 'cademo3'];
export const isCa = caOcs.includes(oc) || oc.startsWith('crashbang');

const rcOcs = ['rcdemo', 'rcdemo1', 'rcdemo8', 'rcdemo9'];
export const isRc = rcOcs.includes(oc);

const tdOcs = ['tddemo'];
export const isTd = tdOcs.includes(oc);

const pgOcs = ['pgdemo'];
export const isPg = pgOcs.includes(oc);

const ppOcs = ['ppdemo'];
export const isPp = ppOcs.includes(oc);

const hsOcs = ['hsdemo'];
export const isHs = hsOcs.includes(oc);

const funOcs = [
  'rcdemo8',
  'rcdemo9',
  'rgdemo8',
  'cademo8',
  'cademo9',
  'cademo2',
  'cldemo2',
];
export const isFun = funOcs.includes(oc);

let title = 'Lobby | Rectangle Games';
let favicon = './favicon.ico';
if (isPxplay) {
  title = 'Lobby | PXPlay';
  favicon = './favicon-pxplay.ico';
} else if (isCa) {
  title = 'Lobby | Casual Games';
  favicon = './favicon-ca.ico';
} else if (isRg) {
  title = 'Lobby | Revenge Games';
  favicon = './favicon-rg.ico';
} else if (isTd) {
  title = 'Lobby | Tada Games';
  favicon = './favicon-td.ico';
} else if (isPg) {
  title = 'Lobby | PGS Games';
  favicon = './favicon-pg.ico';
} else if (isPp) {
  title = 'Lobby | PP Games';
  favicon = './favicon-pp.ico';
} else if (isHs) {
  title = 'Lobby | Hacksaw Games';
  favicon = './favicon-hsw.ico';
}

function Header() {
  const { setPlayerCurrency } = useAppContext();
  const [name, setName] = useState('Username');
  const [balance, setBalance] = useState(0);
  const [currency, setCurrency] = useState('USD');
  const { theme } = useTheme();
  const isDarkTheme = theme === 'dark';

  let logoInvertColor = theme === 'dark';
  let logoSrc = logoRectImg;
  if (isPxplay) {
    logoSrc = isDarkTheme ? logoPxPlayWhiteImg : logoPxPlayBlackImg;
    logoInvertColor = false;
  } else if (isCa) {
    logoSrc = isDarkTheme ? logoCaBlackImg : logoCaWhiteImg;
    logoInvertColor = false;
  } else if (isRg) {
    logoSrc = logoRevengeImg;
  } else if (isTd) {
    logoSrc = logoTdBlackImg;
    logoInvertColor = false;
  } else if (isPg) {
    logoSrc = isDarkTheme ? logoPgWhiteImg : logoPgBlackImg;
    logoInvertColor = false;
  } else if (isPp) {
    logoSrc = isDarkTheme ? logoPpWhiteImg : logoPpBlackImg;
    logoInvertColor = false;
  } else if (isHs) {
    logoSrc = logoHsBlackImg;
  }

  const fetchData = useCallback(async () => {
    const response = await fetch(`/api/v1/authenticate?${params}`);
    const player = await response.json();

    setCurrency(player.currency);
    setPlayerCurrency(player.currency);
    setName(player.id);
    setBalance(player.balance);
  }, [setPlayerCurrency]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link rel="icon" href={favicon} />
      </Helmet>
      <div className="lobby-header">
        <div className="container --custom-container">
          <Navbar expand="lg">
            <Container fluid className="p-0">
              <Navbar.Brand href={window?.location?.href} className="p-0">
                <img
                  src={logoSrc}
                  alt="logo"
                  className={`logo ${logoInvertColor && 'invert'}`}
                />
              </Navbar.Brand>
              <div className="d-flex align-items-center justify-content-end mobile-controls-wrapper">
                <div className="d-flex d-lg-none align-items-center controls-wrapper">
                  <ThemeSwitch />
                  <LanguageSwitch />
                </div>
                <Navbar.Toggle
                  variant="light"
                  className={`navbar-toggle-btn navbar-toggle-btn--${
                    isDarkTheme ? 'dark' : 'light'
                  }`}
                  aria-controls="basic-navbar-nav"
                />
              </div>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto" />
                <div className="d-flex flex-column flex-sm-row gap-1 gap-sm-2 justify-content-end mt-2">
                  <div
                    className="d-flex align-items-center justify-content-end 
                controls-wrapper controls-wrapper--small-mobile"
                  >
                    <ThemeSwitch />
                    <LanguageSwitch />
                  </div>
                  <div className="user-info-wrapper">
                    <Navbar.Text className="user-info d-flex align-items-center notranslate">
                      <PersonCircle />
                      <Button variant="link" href="#">
                        {name}
                      </Button>
                    </Navbar.Text>
                    <div className="divider" />
                    <Navbar.Text className="user-info d-flex align-items-center notranslate">
                      <CashStack />
                      <span className="mx-2">
                        {balance} {currency}
                      </span>
                    </Navbar.Text>
                  </div>
                  <div className="d-none d-lg-flex align-items-center controls-wrapper">
                    <ThemeSwitch />
                    <LanguageSwitch />
                  </div>
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>
      </div>
    </>
  );
}

export default Header;
